export default __webpack_public_path__ + "static/media/team1.7140742a.JPG";